<template>
  <el-date-picker
    ref="domDate"
    v-model="value"
    v-bind="$attrs"
    :type="dateType"
    :name="'c' + formItemMeta.columnId"
    :format="format"
    :value-format="valueFormat"
    :clearable="clearable"
  >
  </el-date-picker>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  // import { ElDatePicker } from 'element-plus'
  // 引入组件需要的属性 引入表单子控件的管理类
  import { itemProps, itemController } from '../map'
  
  /**
   * 月份，一个和范围
   */
  export default defineComponent({
    name: 'nf-el-from-item-year',
    inheritAttrs: false,
    components: {
      // ElDatePicker
    },
    props: {
      ...itemProps, // 基础属性
      format: {
        type: String,
        default: 'YYYY'
      },
      'value-format': {
        type: String,
        default: 'YYYY'
      },
      colName: String, // 变更字段名称
      modelValue: [String, Date, Number, Array]
    },
    emits: ['update:modelValue'],
    setup (props, context) {
      const { value } = itemController(props, context.emit)

      // 根据值是否为数组，判断是否 使用范围。
      const dateType = Array.isArray(value.value) ? 'yearrange' : 'year'

      return {
        dateType,
        value // 控件值
      }
    }
  })
</script>
